export type PrometheusValkeyMemoryUsedStatsBackendApiProps = {
    created: number;
    memory_used: number;
};

export default class PrometheusValkeyMemoryUsedStats {
    readonly created: number;
    readonly memoryUsed: number;

    constructor(props: PrometheusValkeyMemoryUsedStatsBackendApiProps) {
        this.created = props.created;
        this.memoryUsed = props.memory_used;
    }
}
